// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2Ekgj","alertIcon":"ConfirmModal_alertIcon__24tDJ"};